import { v4 as uuidv4 } from "uuid";

const DEVICE_ID_STORAGE_KEY = "deviceId";

export const getOrCreateDeviceId = () => {
  if (typeof window === "undefined" || typeof localStorage === "undefined") {
    return undefined;
  }

  const existingId = localStorage.getItem(DEVICE_ID_STORAGE_KEY);

  if (existingId) {
    return existingId;
  }

  const newId = uuidv4();
  localStorage.setItem(DEVICE_ID_STORAGE_KEY, newId);

  return newId;
};
